export default "__VITE_ASSET__CsSGSg1Y__"